module.exports = __webpack_public_path__ + "img/couple.55a072db.png";